export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Client Intro Scripts and Handouts',
    body: 'Explain art-based work in 30 seconds, so clients, teens and parents say yes before the first line hits the page. Five scripts, three "What to expect" handouts and ready answers to the 8 most common client objections.',
    cover:
      'https://cdn.magicpatterns.com/uploads/9VUpLRRSgL74hyVBsMR7hM/DPS-18-bono-1.png',
    accent: 'bg-sage',
  },
  {
    number: '02',
    title: 'The Scope Checklist',
    body: "Use art-based sessions within your role, whether you're a counselor, social worker or art therapist, and describe your work without claiming a protected title. With the right wording for the US, UK, Canada and Australia.",
    cover:
      'https://cdn.magicpatterns.com/uploads/hEtxRnzcE1H6WpiyJqVdEH/DPS-18-bono-2.png',
    accent: 'bg-peach',
  },
  {
    number: '03',
    title: 'The Whole-Pack Session Index',
    body: 'All 52 sessions on two printable pages, plus a filterable spreadsheet: theme, ages, format, intensity, minimum time and materials. Spot the right session for any client at a glance.',
    cover:
      'https://cdn.magicpatterns.com/uploads/3Th5oNwqeNTDtewRM8xeLK/DPS-18-bono-3.png',
    accent: 'bg-lav',
  },
  {
    number: '04',
    title: 'While They Create',
    body: 'What to do, where to sit and what to say (or not say) during the 20 minutes your client is making art. One-to-one, in groups and online.',
    cover:
      'https://cdn.magicpatterns.com/uploads/fwijG4d5eosy4fXTYKz46n/DPS-18-bono-4.png',
    accent: 'bg-sky',
  },
  {
    number: '05',
    title: 'The Online Art Session Setup Guide',
    body: 'Set up any session for video in 10 minutes: what to ask the client to have at home, how to see their art on camera and how to reduce privacy risks.',
    cover:
      'https://cdn.magicpatterns.com/uploads/aDd21ycyJ6b9NzXPPEv7rJ/DPS-18-bono-5.png',
    accent: 'bg-teal',
  },
]
